export const MARKETPLACE__COURSE_AUDIENCE = {
  PRIMARY_SCHOOL: 'primary_school',
  HIGH_SCHOOL: 'high_school',
  UNIVERSITY: 'university',
  PROFESSIONAL: 'professional'
} as const

export type MarketplaceCourseAudience =
  (typeof MARKETPLACE__COURSE_AUDIENCE)[keyof typeof MARKETPLACE__COURSE_AUDIENCE]

export const MARKETPLACE__COURSE_AUDIENCE_DESCRIPTIONS: Record<MarketplaceCourseAudience, string> =
  {
    [MARKETPLACE__COURSE_AUDIENCE.PRIMARY_SCHOOL]: 'Uczniowie szkół podstawowych',
    [MARKETPLACE__COURSE_AUDIENCE.HIGH_SCHOOL]: 'Uczniowie szkół średnich',
    [MARKETPLACE__COURSE_AUDIENCE.UNIVERSITY]: 'Studenci',
    [MARKETPLACE__COURSE_AUDIENCE.PROFESSIONAL]: 'Osoby pracujące'
  } as const

export const MARKETPLACE__COURSE_DELIVERY_METHOD = {
  ONLINE: 'online',
  OFFLINE: 'offline'
} as const

export type MarketplaceCourseDeliveryMethod =
  (typeof MARKETPLACE__COURSE_DELIVERY_METHOD)[keyof typeof MARKETPLACE__COURSE_DELIVERY_METHOD]

export const MARKETPLACE_COURSE_DELIVERY_METHOD_DESCRIPTIONS: Record<
  MarketplaceCourseDeliveryMethod,
  string
> = {
  [MARKETPLACE__COURSE_DELIVERY_METHOD.ONLINE]: 'Kurs prowadzony zdalnie',
  [MARKETPLACE__COURSE_DELIVERY_METHOD.OFFLINE]: 'Kurs prowadzony stacjonarnie'
} as const
export const MENTOR_REPLY_TIME = {
  STANDARD: '48 godzin',
  MEDIUM: '24 godziny',
  PRIORITY: 'Priorytet odpowiedzi'
} as const

export type MentorReplyTime = (typeof MENTOR_REPLY_TIME)[keyof typeof MENTOR_REPLY_TIME]

export const SUBSCRIPTION = {
  PER_4_WEEKS: '4 tygodnie',
  PER_12_WEEKS: '12 tygodni',
  YEARLY: 'Rok'
} as const

export type Subscription = (typeof SUBSCRIPTION)[keyof typeof SUBSCRIPTION]
